import React from 'react';
import PropTypes from 'prop-types';
import Headline from '@components/atoms/headline/headline';
import Container from '@components/layout/container/container';
import StyledEducationTabletFinished from './educationTabletFinished.style';

function EducationTabletFinished({ shapeBurst }) {
  return (
    <StyledEducationTabletFinished>
      <Container>
        <div className="finished__content">
          {shapeBurst !== '' && (
            <video className="finished__content-video" playsInline autoPlay muted loop>
              <source src={shapeBurst} type="video/mp4" />
            </video>
          )}
          <Headline primary>
            Super! <br /> Du hast es geschafft.
          </Headline>
          <Headline tag="p">nimm dir einen moment und sei stolz auf dich.</Headline>
        </div>
      </Container>
    </StyledEducationTabletFinished>
  );
}

EducationTabletFinished.propTypes = {
  shapeBurst: PropTypes.string.isRequired
};

export default EducationTabletFinished;
